import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import {
  BoosterBlockerCard
} from '@screens/HomePage/MoodMemoryAndFocusPage/BoosterBlockerCard';
import { Badge } from '@viome/viome-base/src/usecase/Home/Home.model';

interface BadgeSectionProps {
  badgeItems: Badge[];
  influencer: 'booster' | 'blocker';
}

export const BadgeSection = ({ badgeItems, influencer }: BadgeSectionProps) => {
  return (
    <div className="space-y-4">
      <Carousel
        className="relative"
        opts={{
          align: 'start',
          dragFree: true,
        }}
      >
        <CarouselContent className="-ml-4">
          {badgeItems?.map((badge: Badge) => (
            <CarouselItem
              key={badge.badge_name}
              className="flex basis-44 !gap-2"
            >
              <BoosterBlockerCard
                badgeItem={badge}
                mood={badge.badge_name}
                influencer={influencer}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious variant="ghost" />
        <CarouselNext variant="ghost" />
      </Carousel>
    </div>
  );
};
